import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { signInUser } from "./Auth";

const RequireAuth = ({ allowRoles }) => {
  const location = useLocation();
  const auth = signInUser();
  // console.log("Require Auth", auth?.type, allowRoles.includes(auth?.type));

  const isAllowed =
    allowRoles.includes(auth?.type) ||
    (auth?.type === "owner" && (allowRoles.includes("admin") || allowRoles.includes("manager")));

  return isAllowed ? (
    <>
      {/* {console.log("user role matched")} */}
      <Outlet />
    </>
  ) : auth?.id ? (
    <Navigate to="/dashboard" state={{ from: location }} replace />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
